/**
 * Conserve aspect ratio of the original region. Useful when shrinking/enlarging
 * images to fit into a certain area.
 *
 * @param {number} sourceWidth width of source image
 * @param {number} sourceHeight height of source image
 * @param {number} maxWidth maximum available width
 * @param {number} maxHeight maximum available height
 * @returns {{ width: number, height: number }}
 */
export const calculateAspectRatioFit = (sourceWidth, sourceHeight, maxWidth, maxHeight) => {
	const ratio = Math.min(maxWidth / sourceWidth, maxHeight / sourceHeight);

	if (sourceHeight < maxHeight && sourceWidth < maxWidth) {
		return {
			width: sourceWidth,
			height: sourceHeight,
		};
	}

	return { width: sourceWidth * ratio, height: sourceHeight * ratio };
};
